<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div>
    <b-row class="mb-1">
      <b-col
        class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center"
      >
        <div class="products-header">
          <h1 class="font-weight-bolder mb-0">
            {{ $t('myProductCatalogs') }}
          </h1>
          <div v-if="stockableContextLabel" class="stockable-highlight mt-1">
            <feather-icon
              icon="MapPinIcon"
              size="18"
              class="stockable-highlight__icon"
            />
            <div class="stockable-highlight__content">
              <span class="stockable-highlight__label">
                {{ stockableContextPrefix }}
              </span>
              <strong class="stockable-highlight__name">
                {{ stockableContextLabel }}
              </strong>
            </div>
          </div>
        </div>
        <div
          v-if="showRegisterButton"
          class="mt-1 mt-md-0"
        >
          <b-button
            :to="registerProductRoute"
            variant="primary"
            class="header-action-button"
          >
            {{ $t('register', { type: $t('product') }) }}
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row
      v-if="showProductSections"
      class="mb-1"
    >
      <b-col class="d-flex align-items-center flex-wrap">
        <b-button-group
          v-if="showStockableSections"
          class="mr-1"
        >
          <b-button
            :variant="stockableSection === 'managed' ? 'primary' : 'outline-primary'"
            :to="{ name: 'supplierProductsCatalogs', params: $route.params, query: { section: 'managed' } }"
          >
            Productos que maneja
          </b-button>
          <b-button
            :variant="stockableSection === 'trash' ? 'primary' : 'outline-primary'"
            :to="{ name: 'supplierProductsCatalogs', params: $route.params, query: { section: 'trash' } }"
          >
            Papelera
          </b-button>
        </b-button-group>
        <b-button-group
          v-else
          class="mr-1"
        >
          <b-button
            :variant="productSection === 'active' ? 'primary' : 'outline-primary'"
            :to="{ name: 'productsCatalogs', query: { section: 'active' } }"
          >
            Activos
          </b-button>
          <b-button
            :variant="productSection === 'deleted' ? 'primary' : 'outline-primary'"
            :to="{ name: 'productsCatalogs', query: { section: 'deleted' } }"
          >
            Eliminados
          </b-button>
        </b-button-group>
        <span class="text-muted">
          {{ paginationTotalObjects }} productos
        </span>
      </b-col>
    </b-row>
    <b-row class="my-1">
      <b-col xs="12" sm="8">
        <b-overlay :show="categoriesLoading" opacity=".9">
          <b-form-input v-model="searchQuery" autocomplete="off" type="text" />
        </b-overlay>
      </b-col>
      <b-col cols="auto" class="mt-1 mt-sm-0">
        <b-button-group>
          <b-button
            :variant="cardMode ? 'secondary' : 'outline-secondary'"
            @click="setCardMode(true)"
          >
            <feather-icon icon="GridIcon" />
          </b-button>
          <b-button
            :variant="cardMode ? 'outline-secondary' : 'secondary'"
            @click="setCardMode(false)"
          ><feather-icon icon="ListIcon" /></b-button>
        </b-button-group>
      </b-col>
      <b-col v-if="cardMode && !isSmallScreen" cols="auto">
        <b-button-group>
          <b-button variant="outline-secondary" @click="tooggleZoom()">
            <feather-icon :icon="zoom ? 'ZoomOutIcon' : 'ZoomInIcon'" />
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="true" sm="12" class="mb-1 d-flex align-items-end flex-wrap">
        <b-form-group class="mb-0 mr-1" :label="$t('perPage')">
          <b-form-select v-model="productsPerPage" :options="perPageOptions" />
        </b-form-group>
        <b-form-group class="mb-0 mr-2" :label="$t('category')">
          <b-dropdown
            variant="outline-primary"
            left
            :text="selectedCategory === null ? $t('all') : selectedCategory"
          >
            <div class="scrollable">
              <b-dropdown-item
                class="mr-1"
                variant="primary"
                @click="setSelectedCategory(null)"
              >
                {{ $t('all') }}
              </b-dropdown-item>
              <b-dropdown-item
                v-for="category in categories"
                :key="`cat-${category.id}`"
                class="mr-1"
                variant="primary"
                @click="setSelectedCategory(category.name)"
              >
                {{ category.name }}
              </b-dropdown-item>
            </div>
          </b-dropdown>
        </b-form-group>
        <b-form-group class="mb-0 product-tags-filter" :label="$t('tags')">
          <v-select
            v-model="selectedTagIds"
            multiple
            label="name"
            :options="tagOptions"
            :reduce="tag => tag.id"
            :placeholder="$t('filterByProductTags')"
            :close-on-select="false"
          />
        </b-form-group>
      </b-col>
      <b-col v-else sm="12">
        <b-button
          pill
          size="sm"
          class="mr-50 mb-50"
          :variant="selectedCategory === null ? 'warning' : 'primary'"
          @click="selectedCategory = null"
        >
          {{ $t('all') }}
        </b-button>
        <b-button
          v-for="category in categories"
          :key="`cat-${category.id}`"
          pill
          size="sm"
          class="mr-50 mb-50"
          :variant="selectedCategory === category.name ? 'warning' : 'primary'"
          @click="selectedCategory = category.name"
        >
          {{ category.name }}
        </b-button>
      </b-col>
    </b-row>
    <b-overlay :show="loading" opacity="1">
      <b-row v-if="cardMode" class="match-height">
        <b-col
          v-for="product in getProdcutsForThisRoute"
          :key="product.id"
          sm="12"
          lg="6"
          :xl="zoom ? '3' : '4'"
          class="mb-2"
        >
          <component
            :is="
              !$route.params.id ? 'products-card' : 'stockable-products-card'
            "
            :product="product"
            :is-discarded="stockableSection === 'trash'"
            @product-updated="fetchData"
          />
        </b-col>
      </b-row>
      <b-row v-else class="match-height">
        <b-col
          v-for="product in getProdcutsForThisRoute"
          :key="product.id"
          sm="12"
          class=""
        >
          <component
            :is="!$route.params.id ? 'product-row' : 'stockable-product-row'"
            :product="product"
            :is-discarded="stockableSection === 'trash'"
            @product-updated="fetchData"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex">
          <b-pagination
            :value="paginationPage"
            :total-rows="paginationTotalObjects"
            :per-page="paginationPerPage"
            aria-controls="my-table"
            @change="nextPage($event)"
          />
        </b-col>
      </b-row>
    </b-overlay>
    <div
      v-if="getProdcutsForThisRoute.length === 0 && !loading"
      class="py-2 display-4"
    >
      No hay productos 😿
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import _ from 'underscore'
import vSelect from 'vue-select'
import { sortProductTags } from '@/libs/productTags'
import StockableProductsCard from '@/components/products/StockableProductCard.vue'
import StockableProductRow from '@/components/products/StockableProductRow.vue'
import ProductsCard from '@/components/products/ProductsCard.vue'
import ProductRow from '@/components/products/ProductRow.vue'

export default {
  components: {
    StockableProductsCard,
    ProductsCard,
    StockableProductRow,
    ProductRow,
    vSelect,
  },

  data() {
    return {
      discardedStockableProducts: {
        meta: {
          pagination: {
            page: 1,
            per_page: 25,
            total_objects: 0,
          },
        },
        data: [],
      },
      searchQuery: null,
      loading: false,
      categoriesLoading: false,
      zoom: false,
      perPageOptions: [
        {
          text: '25',
          value: 25,
        },
        {
          text: '50',
          value: 50,
        },
        {
          text: '100',
          value: 100,
        },
      ],
      productsPerPage: 25,
    }
  },
  computed: {
    ...mapGetters('products', [
      'products',
      'stockableProducts',
      'cardMode',
      'stockableProductsPagination',
      'stockableName',
      'productsPagination',
      'selectedCategory',
      'selectedProductTagIds',
      'availableProductTags',
      'knownProductTagsById',
    ]),
    ...mapGetters('categories', ['categories']),
    tagOptions() {
      const availableIds = new Set(this.availableProductTags.map(tag => tag.id))
      const selectedNotAvailable = this.selectedProductTagIds
        .filter(id => !availableIds.has(id))
        .map(id => this.knownProductTagsById[id])
        .filter(Boolean)

      return sortProductTags([...this.availableProductTags, ...selectedNotAvailable])
    },
    selectedTagIds: {
      get() {
        return this.selectedProductTagIds
      },
      set(value) {
        this.setSelectedProductTagIds(value)
      },
    },
    productTagsFilter() {
      return this.selectedProductTagIds.length ? this.selectedProductTagIds : null
    },
    ...mapGetters('auth', ['currentUser']),
    ...mapGetters('app', ['isSmallScreen', 'currentBreakPoint']),
    registerProductRoute() {
      if (this.$route.name === 'productsCatalogs') {
        return { name: 'registerProduct' }
      }
      if (this.$route.name === 'supplierProductsCatalogs') {
        return {
          name: 'registerSupplierProduct',
          params: { id: this.$route.params.id, type: this.$route.params.type },
        }
      }
      return null
    },
    showRegisterButton() {
      return this.$route.name !== 'productsCatalogs' || this.productSection !== 'deleted'
    },
    stockableContextLabel() {
      if (this.$route.name !== 'supplierProductsCatalogs' || !this.stockableName) {
        return null
      }
      return this.stockableName
    },

    stockableContextPrefix() {
      if (!this.stockableContextLabel) {
        return null
      }

      return this.$route.params.type === 'proveedor'
        ? 'Proveedor seleccionado'
        : 'Sucursal seleccionada'
    },
    showStockableSections() {
      return this.$route.name === 'supplierProductsCatalogs' && this.$route.params.type === 'sucursal'
    },
    showProductSections() {
      return this.showStockableSections || this.$route.name === 'productsCatalogs'
    },
    productSection() {
      return this.$route.name === 'productsCatalogs' && this.$route.query.section === 'deleted'
        ? 'deleted'
        : 'active'
    },
    stockableSection() {
      return this.showStockableSections && this.$route.query.section === 'trash'
        ? 'trash'
        : 'managed'
    },
    getProdcutsForThisRoute() {
      if (this.$route.name === 'productsCatalogs') {
        return this.products
      }
      if (this.$route.name === 'supplierProductsCatalogs') {
        if (this.stockableSection === 'trash') {
          return this.discardedStockableProducts.data
        }
        return this.stockableProducts
      }
      return null
    },
    paginationPage() {
      if (this.$route.name === 'productsCatalogs') {
        return this.productsPagination.page
      }
      if (this.$route.name === 'supplierProductsCatalogs') {
        if (this.stockableSection === 'trash') {
          return this.discardedStockableProducts.meta.pagination.page
        }
        return this.stockableProductsPagination.page
      }
      return null
    },
    paginationTotalObjects() {
      if (this.$route.name === 'productsCatalogs') {
        return this.productsPagination.total_objects
      }
      if (this.$route.name === 'supplierProductsCatalogs') {
        if (this.stockableSection === 'trash') {
          return this.discardedStockableProducts.meta.pagination.total_objects
        }
        return this.stockableProductsPagination.total_objects
      }
      return null
    },
    paginationPerPage() {
      if (this.$route.name === 'productsCatalogs') {
        return this.productsPagination.per_page
      }
      if (this.$route.name === 'supplierProductsCatalogs') {
        if (this.stockableSection === 'trash') {
          return this.discardedStockableProducts.meta.pagination.per_page
        }
        return this.stockableProductsPagination.per_page
      }
      return null
    },
  },
  watch: {
    searchQuery: _.debounce(function search() {
      this.resetPaginationPage()
      this.fetchData()
    }, 400),

    selectedCategory(category) {
      this.resetPaginationPage()

      // Deprecated, no longer deleted products
      if (category === 'deleted') {
        this.fetchProducts({
          by_active_status: false,
          meta: {
            pagination: {
              per_page: 100,
            },
          },
        })
      } else {
        // always executes this since category deleted is deprecated
        this.fetchData()
      }
    },
    productsPerPage(perPage) {
      if (this.$route.name === 'productsCatalogs') {
        this.changeProductsPagination({ field: 'per_page', value: perPage })
      }
      if (this.$route.name === 'supplierProductsCatalogs') {
        if (this.stockableSection === 'trash') {
          this.discardedStockableProducts.meta.pagination.per_page = perPage
        } else {
          this.changeStockablePagination({ field: 'per_page', value: perPage })
        }
      }

      this.resetPaginationPage()
      this.fetchData()
    },
    '$route.query.section': function sectionChanged() {
      this.resetPaginationPage()
      this.fetchData()
    },
    selectedProductTagIds() {
      this.resetPaginationPage()
      this.fetchData()
    },
  },
  created() {
    this.categoriesLoading = true
    this.setSelectedCategory(null)
    this.setSelectedProductTagIds([])
    if (this.$route.name === 'supplierProductsCatalogs' && this.stockableProductsPagination.per_page < 25) {
      this.changeStockablePagination({ field: 'per_page', value: this.productsPerPage })
    }
    this.fetchCategories().then(() => {
      this.categoriesLoading = false
    })
    this.fetchData()
  },
  destroyed() {
    this.clearProducts()
  },
  methods: {
    ...mapMutations('products', {
      setCardMode: 'SET_CARD_MODE',
      clearProducts: 'CLEAR_PRODUCTS',
      changeProductsPagination: 'CHANGE_PRODUCTS_PAGINATION',
      changeStockablePagination: 'CHANGE_STOCKABLE_PAGINATION',
      setSelectedCategory: 'SET_SELECTED_CATEGORY',
      setSelectedProductTagIds: 'SET_SELECTED_PRODUCT_TAG_IDS',
    }),
    ...mapActions('products', [
      'fetchProducts',
      'getStockableProducts',
      'getDiscardedStockableProducts',
    ]),
    ...mapActions('categories', ['fetchCategories']),
    resetPaginationPage() {
      if (this.$route.name === 'productsCatalogs') {
        this.changeProductsPagination({ field: 'page', value: 1 })
      }

      if (this.$route.name === 'supplierProductsCatalogs') {
        if (this.stockableSection === 'trash') {
          this.discardedStockableProducts.meta.pagination.page = 1
        } else {
          this.changeStockablePagination({ field: 'page', value: 1 })
        }
      }
    },
    fetchData() {
      this.loading = true

      if (this.$route.name === 'productsCatalogs') {
        this.fetchProducts({
          by_active_status: this.productSection !== 'deleted',
          by_category: this.selectedCategory ? this.selectedCategory : null,
          by_name: this.searchQuery ? this.searchQuery : null,
          by_product_tags: this.productTagsFilter,
          meta: {
            pagination: this.productsPagination,
          },
        }).then(() => {
          this.loading = false
        })
      } else if (this.$route.name === 'supplierProductsCatalogs') {
        let type = ''
        if (this.$route.params.type === 'proveedor') {
          type = 'Supplier'
        }
        if (this.$route.params.type === 'sucursal') {
          type = 'SupplierBranch'
        }
        const params = {
          by_category: this.selectedCategory ? this.selectedCategory : null,
          by_name: this.searchQuery ? this.searchQuery : null,
          by_product_tags: this.productTagsFilter,
          by_active_status: true,
          meta: {
            pagination: this.stockableSection === 'trash'
              ? this.discardedStockableProducts.meta.pagination
              : this.stockableProductsPagination,
          },
        }
        const stockable = {
          id: this.$route.params.id,
          type,
        }

        if (this.stockableSection === 'trash') {
          this.getDiscardedStockableProducts({
            params,
            stockable,
          }).then(response => {
            this.discardedStockableProducts = {
              meta: response.meta || this.discardedStockableProducts.meta,
              data: response.data || [],
            }
            this.loading = false
          })
          return
        }

        this.getStockableProducts({
          params: {
            by_category: this.selectedCategory ? this.selectedCategory : null,
            by_name: this.searchQuery ? this.searchQuery : null,
            by_product_tags: this.productTagsFilter,
            by_active_status: true,
            meta: {
              pagination: this.stockableProductsPagination,
            },
          },
          stockable,
        }).then(() => {
          this.loading = false
        })
      }
    },
    filterBy() {
      this.fetchData()
    },

    tooggleZoom() {
      this.zoom = !this.zoom
    },

    nextPage(value) {
      if (this.$route.name === 'productsCatalogs') {
        this.changeProductsPagination({ field: 'page', value })
        this.fetchData()
      }

      if (this.$route.name === 'supplierProductsCatalogs') {
        if (this.stockableSection === 'trash') {
          this.discardedStockableProducts.meta.pagination.page = value
        } else {
          this.changeStockablePagination({ field: 'page', value })
        }
        this.fetchData()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-padding {
  padding-bottom: 7px;
}

.products-header {
  width: 100%;
  max-width: 840px;
}

.stockable-highlight {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  width: fit-content;
  max-width: 100%;
  padding: 0.65rem 0.85rem;
  border: 1px solid #d9e2ef;
  border-left: 4px solid var(--primary);
  border-radius: 0.7rem;
  background: linear-gradient(135deg, #f8fafc 0%, #eef4ff 100%);
  box-shadow: 0 2px 10px rgba(34, 41, 47, 0.08);
}

.stockable-highlight__icon {
  color: var(--primary);
  flex-shrink: 0;
}

.stockable-highlight__content {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.stockable-highlight__label {
  font-size: 0.72rem;
  line-height: 1.1;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #5e6878;
}

.stockable-highlight__name {
  margin-top: 0.15rem;
  font-size: 1rem;
  line-height: 1.25;
  color: #202733;
  word-break: break-word;
}

.header-action-button {
  white-space: nowrap;
}

.scrollable {
  max-height: 300px !important; /* Ajusta el valor a la altura deseada */
  overflow-y: auto;
}

.product-tags-filter {
  flex: 1 1 auto;
  min-width: 260px;
  max-width: 520px;
}

@media (max-width: 767.98px) {
  .stockable-highlight {
    width: 100%;
  }
}
</style>
